import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable({
    providedIn: 'root'
})
export class EventsService {
    studentAmountSubject$ = new BehaviorSubject(0);

    constructor() {}
}
